import './ProxySQLDetailsModal.less';
import React from 'react';
import { Row, Space } from 'antd';
import ModalDefault from '../../../../common/ModalDefault';
import CcProxySqlNode from '../../../../services/models/CcProxySqlNode';
import SpaceDescriptions from '../../../../common/Layout/SpaceDescriptions';
import NodeFormat from '../../NodeFormat';
import ProxySQLDetailsPage from './ProxySQLDetailsPage';
import CcCluster from '../../../../services/models/CcCluster';
import AppPageWrapper from '../../../../common/Layout/AppPageWrapper';

export default ProxySQLDetailsModal;

export type ProxySQLDetailsModalProps = {
    node: CcProxySqlNode;
    cluster: CcCluster;
    onCancel?: () => void;
};

function ProxySQLDetailsModal({
    cluster,
    node,
    onCancel,
}: ProxySQLDetailsModalProps) {
    return (
        <ModalDefault
            title="Node details"
            visible={true}
            width={'90%'}
            onCancel={() => onCancel?.()}
        >
            <AppPageWrapper
                transparent={true}
                contentProps={{ style: { border: 0 } }}
                contentClassName="ProxySQLDetailsModal"
            >
                <Row justify="space-between">
                    <Space direction="vertical" align="start" size={0}>
                        <SpaceDescriptions direction={'vertical'}>
                            <NodeFormat
                                key={node?.hostname}
                                node={node}
                                size="large"
                            />
                        </SpaceDescriptions>
                    </Space>
                </Row>
                <ProxySQLDetailsPage cluster={cluster} node={node} />
            </AppPageWrapper>
        </ModalDefault>
    );
}
